export const isUuid = (value: string) => {
  const generalUUIDRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return generalUUIDRegex.test(value);
};

export const isValidUrl = (url: string | undefined | null) => {
  if (!url) return false;
  try {
    return !!new URL(url).origin;
  } catch {
    return false;
  }
};
